<template>
<div class="wlx-apply-table-wrappers">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
        <div class="basic-head-con">
            <div class="head-title-con clearfix">
                <div class="fl basic-book-img-con">
                    <img src="~assets/images/basic-book-img.png" alt />
                </div>
                <div class="fr head-title-word">
                    <p class="p-title-1">考试报名申请表</p>
                    <p class="p-title-2 p-title-2-1">——中国饭店协会</p>
                </div>
            </div>
        </div>
    </div>
    <div class="apply-table-content">
        <table border="0" cellspacing="0" cellpadding="0" class="wlx-table-exam">
            <tr>
                <td colspan="1" class="u-label-title">申报单位</td>
                <td colspan="3">{{schoolName}}</td>
            </tr>
            <tr>
                <td colspan="1" class="u-label-title">单位地址</td>
                <td colspan="3">
                    <b>省份:</b><span>{{province}}</span>
                    &nbsp;&nbsp;<b>城市:</b><span>{{city}}</span>
                    &nbsp;&nbsp;<b>县/区:</b><span>{{area}}</span>
                </td>
            </tr>
            <tr>
                <!-- <td colspan="1" class="u-label-title">报名账号</td>
          <td colspan="1">{{bmName}}</td> -->
                <td colspan="1" class="u-label-title">考务账号</td>
                <td colspan="3">{{kdName}}</td>
            </tr>
            <tr>
                <td colspan="1" class="u-label-title">考试人数</td>
                <td colspan="1">
                    <el-input disabled v-model="enrolmentCount"></el-input>
                </td>
                <td colspan="1" class="u-label-title">考试级别</td>
                <td colspan="1">
                    <el-select v-model="examLevel" disabled clearable placeholder="请选择考试等级">
                        <el-option v-for="item in ExamLevelList" :key="item.value" :label="item.value" :value="item.lable"></el-option>
                    </el-select>
                </td>
            </tr>
            <tr>
                <td colspan="1" class="u-label-title">考试时间</td>
                <td colspan="3">
                    <!-- <el-select v-model="examDate" disabled clearable placeholder="请选择考试时间">
              <el-option
                v-for="item in ExamDateList"
                :key="item.StartTime"
                :label="item.StartTime"
                :value="item.Id"
              ></el-option>
            </el-select>-->
                    <el-input disabled v-model="examDate"></el-input>
                </td>
                <!-- <td colspan="1" class="u-label-title">实操考场数</td>
          <td colspan="1">
            <el-input disabled v-model="examNum"></el-input>
          </td> -->
            </tr>

            <tr>
                <td colspan="1" class="u-label-title"></td>
                <td colspan="1" class="u-label-title">姓名</td>
                <td colspan="2" class="u-label-title">手机号</td>
            </tr>
            <tr>
                <td colspan="1" class="u-label-title">总负责人</td>
                <td colspan="1">
                    <el-input disabled v-model="zname"></el-input>
                </td>
                <td colspan="2">
                    <el-input disabled v-model="zphone"></el-input>
                </td>
            </tr>
            <!-- <tr>
          <td colspan="1" class="u-label-title">实训场地管理员</td>
          <td colspan="1">
            <el-input disabled v-model="sname"></el-input>
          </td>
          <td colspan="2">
            <el-input disabled v-model="sphone"></el-input>
          </td>
        </tr> -->
            <tr>
                <td colspan="1" class="u-label-title">考务管理员</td>
                <td colspan="1">
                    <el-input disabled v-model="kname"></el-input>
                </td>
                <td colspan="2">
                    <el-input disabled v-model="kphone"></el-input>
                </td>
            </tr>
            <!-- <tr>
          <td colspan="1" class="u-label-title">报名管理员</td>
          <td colspan="1">
            <el-input disabled v-model="bname"></el-input>
          </td>
          <td colspan="2">
            <el-input disabled v-model="bphone"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="1" class="u-label-title">机房管理员</td>
          <td colspan="1">
            <el-input disabled v-model="jname"></el-input>
          </td>
          <td colspan="2">
            <el-input disabled v-model="jphone"></el-input>
          </td>
        </tr> -->
            <tr>
                <td colspan="1" class="u-label-title">手持型号及数量</td>
                <td colspan="3">
                    <el-input disabled v-model="handheldModel"></el-input>
                </td>
            </tr>
            <tr>
                <td colspan="1" class="u-label-title"><span style="color:red;margin-right: 3px">*</span>实操考场数</td>
                <td colspan="3">
                    <!-- <el-input v-model="siteNum"></el-input> -->
                    <el-input-number disabled v-model="examNum"></el-input-number>
                    个
                </td>
            </tr>
        </table>
        <div class="submit-apply-btn">
            <el-button type="primary" @click="goback">返回</el-button>
            <el-button type="primary" @click="goDelete">删除</el-button>
        </div>
    </div>
</div>
</template>

<script>
import avatarUpload from "components/avatarUpload.vue";

export default {
    data() {
        return {
            ExamLevelList: [{
                    lable: 1,
                    value: "初级"
                },
                {
                    lable: 2,
                    value: "中级"
                },
                {
                    lable: 3,
                    value: "高级"
                }
            ],
            radio: 0,
            headBg: require("assets/images/wlx-baic-bg-img.png"),
            // firstCount:5000,
            // secondCount:10000,
            // thirdCount:10000,
            // fourthCount:10000,
            // examtCount:"",
            enrolmentCount: 0,
            zname: "",
            zphone: "",
            sname: "",
            sphone: "",
            kname: "",
            kphone: "",
            bname: "",
            bphone: "",
            jname: "",
            jphone: "",
            examDate: "",
            handheldModel: "",
            schoolName: "",
            bmName: "",
            kdName: "",
            examLevel: 0,
            examNum: 0,
            province: "",
            city: "",
            area: ""
        };
    },
    props: {
        examId: {
            type: String,
            default: ""
        }
    },
    components: {},
    created() {
        this.getMeetingEnrollInfo();
    },
    methods: {
        goDelete() {
            var that = this;
            this.$confirm("此操作将删除该考试申报信息, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    this.$http
                        .post("/api/XOrg/ExamSingUpManager/deleteExamSchool", {
                            ids: that.examId
                        })
                        .then(rst => {
                            if (rst.code > 0) {
                                that.$message.success(rst.msg);
                                that.$router.push({
                                    name: "examManager"
                                });
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },

        // surplusNumber(){
        //   console.log(this.radio);
        //   if(this.radio == 1){
        //   if(this.enrolmentCount>this.firstCount){
        //     this.$message.warning('报考人数超出该时间段剩余人数！');
        //   }
        //   }else if(this.radio ==2){
        //   if(this.enrolmentCount>this.secondCount){
        //     this.$message.warning('报考人数超出该时间段剩余人数！');
        //   }
        //   }else if(this.radio ==3){
        //   if(this.enrolmentCount>this.thirdCount){
        //     this.$message.warning('报考人数超出该时间段剩余人数！');
        //   }
        //   }else if(this.radio == 4){
        //   if(this.enrolmentCount>this.fourthCount){
        //     this.$message.warning('报考人数超出该时间段剩余人数！');
        //   }
        //   }
        // },

        //获取报名详情
        getMeetingEnrollInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/ExamSingUpManager/getMeetingEnrollInfo", {
                    id: that.examId
                })
                .then(rst => {
                    that.schoolName = rst.info.SchoolName;
                    that.bmName = rst.info.BmName;
                    that.kdName = rst.info.KdName;
                    that.examLevel = rst.info.ExamLevel;
                    that.examDate = rst.info.ExamDate;
                    that.enrolmentCount = rst.info.StudentNumber;
                    that.zname = rst.info.ExamMainName;
                    that.zphone = rst.info.ExamMainPhone;
                    that.sname = rst.info.ExamPlaceName;
                    that.sphone = rst.info.ExamPlacePhone;
                    (that.kname = rst.info.ExaminationName),
                    (that.kphone = rst.info.ExaminationPhone),
                    (that.bname = rst.info.SchoolSingUpName);
                    that.bphone = rst.info.SchoolSingUpPhone;
                    that.jname = rst.info.ExamRoomMangerName;
                    that.jphone = rst.info.ExamRoomMangerPhone;
                    that.handheldModel = rst.info.PDAType;
                    that.examNum = rst.info.ExamNum;
                    that.province = rst.info.Province;
                    that.city = rst.info.City;
                    that.area = rst.info.Area;
                });
        },
        //返回
        goback() {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="scss">
.wlx-apply-table-wrappers {
    height: 100%;
    overflow: auto;
    background: #f0f6ff;

    .basic-head-main {
        height: 706px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center top;

        .basic-head-con {
            margin: 0 auto;
            width: 1000px;
        }

        .head-logo-con {
            padding: 26px 0 0 26px;
        }

        .logo-img-val {
            height: 40px;
        }

        .head-title-con {
            position: relative;
            padding-top: 40px;
        }

        .basic-book-img-con {
            margin-left: 10px;

            img {
                width: 290px;
            }
        }

        .head-title-word {
            position: absolute;
            right: 0;
            top: 130px;
            z-index: 100;
            color: #fff;
        }

        .p-title-1 {
            font-size: 55px;
            font-weight: bold;
            text-align: center;
        }

        .p-title-2-1 {
            margin-top: 50px;
            text-align: right;
            font-size: 20px;
        }
    }

    .apply-table-content {
        margin: -346px auto 0;
        padding: 20px 0;
        padding-top: 50px;
        width: 1000px;
        background: #fff;
    }

    .p-down-applyTable-btn {
        text-align: right;
        color: #0365f5;
        padding: 0 22px 20px 0;
        cursor: pointer;
        font-size: 17px;
    }

    .apply-table-title {
        padding: 20px 0;
        text-align: center;
    }

    .submit-apply-btn {
        padding: 20px 0;
        text-align: center;

        .el-button--primary {
            background: #05243D;
            border-color: #05243D;
        }
    }

    .label-job-con {
        padding: 0 20px;
    }

    table {
        margin: 0 auto;
        width: 960px;
        border-right: 1px solid #999;
        border-bottom: 1px solid #999;
        table-layout: fixed;
        word-break: break-all;
        background: #f0f0f0;

        .el-input.is-disabled .el-input__inner {
            color: #7e828a;
        }
    }

    .u-label-title {
        font-weight: bold;
    }

    .demo-table {
        margin-top: 100px;
    }

    .expert-certify-ul {
        height: 100%;
    }

    .expert-certify-li {
        width: 25%;
    }

    .certify-li-cell {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
    }

    .certify-li-cell-num {
        border-top: none;
    }

    .fistCertify {
        .certify-li-cell {
            border-left: none;
        }
    }

    .el-textarea__inner,
    .el-input__inner {
        border: none;
        font-size: 16px;
        color: #000;
    }

    .input-edu .el-input__inner {
        height: 82px;
        line-height: 82px;
    }

    .el-textarea__inner:focus {
        border: none;
    }

    .el-input__inner:focus {
        border: none;
    }

    .el-date-editor.el-input {
        width: 100%;
    }

    table td {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
        text-align: center;
    }

    .label-opinion-title {
        padding: 10px;
        text-align: left;
    }

    .sp-mark-label {
        color: red;
    }

    .h4-major-title {
        padding: 10px 0;
    }

    td {
        height: 40px;
        // width: 76.9px;
        font-size: 16px;
    }
}
</style>
